import { useAppDispatch } from "@/utils";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";
import { FC } from "react";
import { useMessagedAsyncRetry } from "@payping/web-components";
import { bnplMerchantGetContract } from "@payping/redux/actions";
import BnplActivationPageFormInitSettingCredit from "./Credit";
import { useAtom } from "jotai";
import { selectAtom } from "jotai/utils";
import { installmentPaymentAtom } from "../../../state";

const activationStepAtom = selectAtom(installmentPaymentAtom, (val) => val.bnplActivationStep);

interface InitSettingsProps {
  onFinish: (activationSep: ActivationSteps) => void;
}
const BnplActivationPageFormInitSetting: FC<InitSettingsProps> = ({ onFinish }) => {
  const [activationStepSate] = useAtom(activationStepAtom);

  const dispatch = useAppDispatch();

  const contractState = useMessagedAsyncRetry(() => dispatch(bnplMerchantGetContract()), [], { success: false });

  if (activationStepSate === ActivationSteps.SetWalletCreditAmount) {
    return (
      <BnplActivationPageFormInitSettingCredit
        onFinish={() => {
          onFinish(ActivationSteps.CompleteMerchantProfileInfo);
          contractState.retry();
        }}
      />
    );
  }

  // if (bnplActivationStep === ActivationSteps.SetMinPrePaymentRate) {
  //   return (
  //     <BnplActivationPageFormInitSettingPrePayment
  //       onFinish={() => {
  //         onFinish(ActivationSteps.SetMonthlyInterestRate);
  //         contractState.retry();
  //       }}
  //       goBack={() => goBack(ActivationSteps.SetWalletCreditAmount)}
  //     />
  //   );
  // }

  // if (bnplActivationStep === ActivationSteps.SetMonthlyInterestRate) {
  //   return (
  //     <BnplActivationPageFormInitSettingMonthlyInterest
  //       onFinish={() => {
  //         onFinish(ActivationSteps.CompleteMerchantProfileInfo);
  //         contractState.retry();
  //       }}
  //       goBack={() => goBack(ActivationSteps.SetMinPrePaymentRate)}
  //     />
  //   );
  // }
  return null;
};

export default BnplActivationPageFormInitSetting;
